import axios from "axios";
import { useState } from "react";
import Swal from "sweetalert2";

const QuickBar = () => {
  const [name, setName] = useState<string>("");
  const [phone, setPhone] = useState<string>("");
  const [address, setAddress] = useState<string>("");

  const [loading, setLoading] = useState(false);

  const handlerPostContact = async () => {
    if (!name || !phone || !address) {
      Swal.fire({
        title: "이름, 연락처, 주소를 모두 입력해주세요.",
        icon: "error",
      });
      return false;
    }

    if (phone.length !== 11 || !phone.includes("010")) {
      alert("010을 포함한 연락처를 모두 입력해주세요.");
      return false;
    }

    if (!window.confirm("문의 접수를 위한 개인정보 수집에 동의하시나요?")) {
      return false;
    }

    setLoading(true);

    await axios
      .post("/api/contact/quick", {
        name: name,
        phone: phone,
        address: address,
        path: sessionStorage.getItem("path"),
      })
      .then((res) => {
        if (res.data.result === "0000") {
          Swal.fire({
            title: "문의 완료!",
            text: "문의 등록이 완료되었습니다.",
            icon: "success",
          }).then(() => (window.location.href = "/transform"));
        }
      })
      .catch((e) => {
        setLoading(false);
        Swal.fire({
          title: e,
          icon: "error",
        }).then(() => (window.location.href = "/"));
      });
  };

  return (
    <div className="hidden xl:block fixed left-0 bottom-2.5 w-full h-fit px-[calc((100%-var(--container))/5)] z-40">
      <div className=" relative w-full h-full bg-[#0147c2] flex justify-between items-center gap-5 px-8 rounded-full border-3 border-[#0147c2]">
        <div className="relative w-fit h-full">
          <img
            className="!relative w-auto h-full max-h-12"
            src="/images/white_logo.png"
            alt="number"
            width={584}
            height={107}
          />
        </div>
        <div className=" relative w-1 h-10 border-r"></div>
        <div className="relative w-fit h-full cursor-pointer">
          <img
            className="!relative w-auto h-full max-h-12"
            src="/images/quick_num.png"
            alt="number"
            width={584}
            height={107}
          />
        </div>
        <div className=" relative w-fit h-full min-w-[600px] grid grid-cols-7 gap-3">
          <div className="col-span-2 relative w-full h-full">
            <label
              htmlFor="name1"
              className=" absolute left-1.5 z-10 top-2 lg:text-xl text- font-semibold"
            >
              이름
            </label>
            <input
              type="text"
              value={name}
              className="!pl-12"
              id="name1"
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div className="col-span-2 relative w-full h-full">
            <label
              htmlFor="phone1"
              className=" absolute left-1.5 z-10 top-2 lg:text-xl text- font-semibold"
            >
              연락처
            </label>
            <input
              className="!pl-16"
              type="text"
              id="phone1"
              value={phone}
              maxLength={11}
              onChange={(e) =>
                setPhone(
                  e.target.value
                    .replace(/[^0-9.]/g, "")
                    .replace(/(\..*)\./g, "$1")
                )
              }
            />
          </div>
          <div className="col-span-3 relative w-full h-full">
            <label
              htmlFor="address1"
              className=" absolute left-1.5 z-10 top-2 lg:text-xl text- font-semibold"
            >
              주소&nbsp;
            </label>
            <div>
              <input
                className="!pl-12"
                type="text"
                value={address}
                id="address1"
                onChange={(e) => setAddress(e.target.value)}
              />
            </div>
          </div>
        </div>
        <button
          type="button"
          onClick={handlerPostContact}
          disabled={loading}
          className=" relative w-fit h-fit py-2 px-5 text-point"
        >
          <h2 className="manru text-shadow">전송</h2>
        </button>
      </div>
    </div>
  );
};

export default QuickBar;
